import React, { Component } from 'react';
import { connect } from 'react-redux';

import Prospect from './prospect';
import BasicUser from './basicUser';
import User from './user';
import '../styles/info.css';

import withRouter from 'withRouter';

class Info extends Component<any, any> {
  render() {
    return (
      <div>
        {this.props.router.params.userType === 'prospect' ? (
          <Prospect />
        ) : this.props.router.params.userType === 'basicuser' ? (
          <BasicUser />
        ) : (
          <User />
        )}
      </div>
    );
  }
}

export default connect(null, null)(withRouter(Info));
